export enum AccountTabTypeEnum {
  AccountInformation = "account-information",
  ActiveAlarms = "active-alarms",
  AlarmHistory = "alarm-history",
  Wallet = "wallet",
}
